(function () {


  'use strict';

  /**
   * @ngdoc provider
   * @name uteEndpointProvider
   * @description  uteEndpoint configuration object
   */
  angular.module('eclipseApp.core')

    .provider('genesisEndpoint', function () {
      this.basePath = '';

      this.setBasePath = function(basePath){
        console.log('setter called by :', basePath);
        this.basePath = basePath;
      };
      this.$get = function () {
        var _this = this;
        return function (key) {
          console.log('url : ', key);

          return _this.basePath + '/' + key;
        }
      }
    });

})();
